module.exports = __webpack_public_path__ + "4bbc0be1cd9a867c4f9e5de00e724f6a.jpg";